import React from "react";
import { Link } from "react-router-dom";
import CallActionBg from "../Assets/img/call-action-bg.svg";
const CallAction = () => {
  return (
    <>
      <section
        className="call-action-area"
        style={{ backgroundImage: `url(${CallActionBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-7 col-12">
              <div className="call-action-content">
                <h3 className="c-title">
                  Order now & Get Awesome <br /> Features! Try ISP Digital Now!
                </h3>
                <div className="call-action-btn">
                  <Link to="#" className="theme-btn primary">
                    <i className="icofont-arrow-right"></i>Order Now
                  </Link>
                  <Link to="#" className="theme-btn">
                    <i className="icofont-arrow-right"></i>Demo Request
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CallAction;
